import { DataBlockDictionaryDto, DataType } from '@lmt/shared-types';
import {
  Button,
  ButtonColor,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { useCallback } from 'react';
import { useFieldArray } from 'react-hook-form';
import { UseFormReturn } from 'react-hook-form/dist/types';
import { DictionaryData } from './common';

import styles from './ConfigureColumns.module.scss';
import { DictionaryColumn } from './DictionaryColumn';

type Props = {
  form: UseFormReturn<DictionaryData>;
};
export const ConfigureColumns = (props: Props) => {
  const form = props.form;
  const i18n = useScopedTranslation('custom_dictionary.configure');

  const columns = useFieldArray({
    control: form.control,
    name: 'columns',
    keyName: '_id',
    shouldUnregister: true,
  });
  const removeColumn = useCallback((index: number) => {
    columns.remove(index);
  }, []);

  const addColumn = useCallback(() => {
    columns.append([
      {
        id: null,
        dataType: DataType.Text,
        title: '',
        isUnique: false,
        referenceDictionaryId: null,
      } as any,
    ]);
  }, []);
  return (
    <div className={styles.columnsContainer}>
      {columns.fields.map((column, index) => (
        <div key={column._id} className={styles.columnInfo}>
          <DictionaryColumn form={form} column={column} index={index} />
          <Button
            type={'button'}
            color={ButtonColor.Danger}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              removeColumn(index);
            }}
            disabled={column.required}
            title={i18n.t('remove_column_button')}
            className={styles.buttonRemoveColumn}
          />
        </div>
      ))}
      <div>
        <Button
          type={'button'}
          color={ButtonColor.Primary}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            addColumn();
          }}
          title={i18n.t('add_column_button')}
        ></Button>
      </div>
    </div>
  );
};
